/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types,react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { t } from 'utils/translates';

import FilterSelect from 'components/Common/Inputs/FilterSelect';
import SortLabelColumnToggle from 'components/Common/Inputs/SortLabelColumnToggle';

import {
  selectItemById,
  selectItemsIds,
  sendRequest,
  changeQueryParams,
  selectRequestState,
  selectPagination,
  selectQueryParams,
  changeDefaultQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

import { selectItemById as selectUserById } from 'mt-react-common/common/reducers/objectCollection/reducer';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';

import UserBlackListTableItem from './UserBlackListTableItem';
import PaginationBlock from '../../../Common/Pagination/PaginationBlock/PaginationBlock';
import OpacityPreLoader from '../../../Common/PreLoaders/OpacityPreLoader';
import SearchInput from '../../../Common/Inputs/SearchInput/index';

import RemoveUserBlackListPopUp from '../../RemoveUserBlackListPopUp';

class UserBlackListTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultQueryParams: {
        page: 1,
        userSearch: null,
        causes_id: null
      },
      showRemoveUserBlackListPopUp: false,
      removeBlockedUserId: null
    };
    this.props.changeDefaultQueryParams(this.state.defaultQueryParams);
    this.props.sendRequest();
  }

  render() {
    const causesOptions = this.props.userBlackListCauses
      .filter(item => item.category === this.props.categoryId)
      .map(item => ({ value: item.id, title: item.title }));
    return (
      // eslint-disable-next-line react/prop-types
      <div>
        <RemoveUserBlackListPopUp
          categoryId={this.props.categoryId}
          in={this.state.showRemoveUserBlackListPopUp}
          blockedUserId={this.state.removeBlockedUserId}
          handleClose={() => {
            this.setState({
              showRemoveUserBlackListPopUp: false
            });
          }}
          handleSuccessQuery={() => {
            this.props.sendRequest();
          }}
        />
        {this.props.requestState.inProgress ? <OpacityPreLoader /> : null}
        <form className="form-inline" onSubmit={e => e.preventDefault()}>
          <div className="form-group btn-group pull-right">
            <FilterSelect
              titleSelectAll={t('Все')}
              startValue={this.props.selectQueryParams.causes_id}
              handleChangeValue={value => {
                this.props.changeQueryParams({
                  page: 1,
                  causes_id: value
                });
                this.props.sendRequest();
              }}
              options={causesOptions}
            />
          </div>
          <div className="form-group">
            <label className="sr-only" htmlFor="referralSearch">
              {t('Поиск')}
            </label>
            <SearchInput
              type="search"
              className="form-control ng-pristine ng-valid ng-touched"
              id="referralSearch"
              placeholder={t('Поиск')}
              onChange={e => {
                this.props.changeQueryParams({
                  page: 1,
                  userSearch: e.target.value
                });
                this.props.sendRequest();
              }}
              value={this.props.selectQueryParams.userSearch}
            />
          </div>
        </form>
        <div className="table-responsive">
          <table className="table table-sortible table-hover m-b-0">
            <thead>
              <tr>
                <th className="no-sort">{t('Пользователь')}</th>
                <th className="no-sort">{t('Причина')}</th>
                <th className="no-sort">{t('Комментарий')}</th>
                <SortLabelColumnToggle
                  label={t('Дата')}
                  tag="th"
                  defaultValue="created_at"
                  selectedValue={this.props.selectQueryParams.sort}
                  handleChangeSortValue={sortValue => {
                    this.props.changeQueryParams({
                      sort: sortValue
                    });
                    this.props.sendRequest();
                  }}
                />
                <th className="no-sort" />
              </tr>
            </thead>
            <tbody>
              {this.props.itemsIds.length > 0 ? (
                <React.Fragment>
                  {this.props.itemsIds.map(itemId => (
                    <UserBlackListTableItem
                      key={`UserBlackListTableItem${itemId}`}
                      item={this.props.selectItemById(itemId)}
                      causes={causesOptions}
                      openRemovePopUp={blockedUserId => {
                        this.setState({
                          showRemoveUserBlackListPopUp: true,
                          removeBlockedUserId: blockedUserId
                        });
                      }}
                    />
                  ))}
                </React.Fragment>
              ) : (
                <tr>
                  <td className="text-center" colSpan="5">
                    {t('Пользователи не найдены')} :-(
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="table-footer">
          <PaginationBlock
            paginationData={this.props.pagination}
            handlePageClick={pageNumber => {
              this.props.changeQueryParams({ page: pageNumber });
              this.props.sendRequest();
            }}
          />
        </div>
      </div>
    );
  }
}

UserBlackListTable.propTypes = {
  // IN
  categoryId: PropTypes.number.isRequired,

  // CONNECT
  changeDefaultQueryParams: PropTypes.func.isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  selectUserById: PropTypes.func.isRequired,
  selectQueryParams: PropTypes.shape({
    userSearch: PropTypes.string,
    createdFrom: PropTypes.string,
    createdTo: PropTypes.string,
    sort: PropTypes.string
  }).isRequired,
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired
  }).isRequired,

  pagination: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired
};

const mapStateToProps = (state, props) => ({
  requestStatusData: selectRequestState(state, props.listReduceName),
  pagination: selectPagination(state, props.listReduceName),
  itemsIds: selectItemsIds(state, props.listReduceName),
  selectItemById: id => selectItemById(state, props.listReduceName, id),
  selectQueryParams: selectQueryParams(state, props.listReduceName),
  selectUserById: id =>
    selectUserById(state, 'usersModule.collections.userCollection', id),
  userBlackListCauses: getItemFromRefList(state, 'userBlackListCauses')
});

const mapDispatchToProps = (dispatch, props) => ({
  changeDefaultQueryParams: queryParams =>
    dispatch(changeDefaultQueryParams(props.listReduceName, queryParams)),
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(props.listReduceName, queryParams)),
  sendRequest: () => dispatch(sendRequest(props.listReduceName))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserBlackListTable)
);



// WEBPACK FOOTER //
// ./src/components/UserBlackList/UserBlackListTable/common/UserBlackListTable.js